import { Box, Button, Flex, Heading, Input, InputGroup, SimpleGrid, Text } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDebouncedFieldRegistry } from '@/utils/filterUtils/useDebouncedFieldRegistry';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import { SelectField } from '@/components/SelectField';
import { RosterMemberFilters } from '../../types';
import { Club, RosterGroup } from '@/model';
import TeamFilterSelect from '@/components/TeamFilterSelect';

export interface RosterMemberFilterBoxProps {
  clubs: Club[];
  groups: RosterGroup[];
  filtersForm: UseFormReturn<RosterMemberFilters>;
  forceRefetch: () => void;
}

export const RosterMemberFilterBox = ({ clubs, groups, filtersForm }: RosterMemberFilterBoxProps) => {
  const { t } = useTranslation();
  const { register, reset } = filtersForm;

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle'>
          {t('pages.application_roster_member.components.roster_member_filter_box.roster_member_filter_box_title')}
        </Heading>
      </Flex>

      <Flex direction={{ base: 'column' }} gap='small' rowGap='micro'>
        <SimpleGrid
          gap='deka'
          alignItems='flex-end'
          columns={{ base: 1, sm: 2, md: 4, lg: 5, xl: 6 }}
          rowGap='xxsmall'
          flexGrow={1}
        >
          <TeamFilterSelect showFlag name='team_uuid' control={filtersForm.control} clubs={clubs} width='100%' />

          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'>
              {t('pages.application_roster_member.components.roster_member_filter_box.roster_member_filter_box_name')}
            </Text>
            <Input variant='flushed' {...useDebouncedFieldRegistry(() => register('name'))} />
          </InputGroup>

          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'>
              {t('pages.application_roster_member.components.roster_member_filter_box.roster_member_filter_box_group')}
            </Text>
            <SelectField {...register('group_uuid')}>
              <option value=''>
                {t('pages.application_roster_member.components.roster_member_filter_box.roster_member_filter_box_group_default')}
              </option>
              {groups.map(group => (
                <option key={group.uuid} value={group.uuid}>
                  {group.name}
                </option>
              ))}
            </SelectField>
          </InputGroup>
        </SimpleGrid>

        <Button alignSelf={{ lg: 'end' }} colorScheme='text' variant='outline' mt='10px' onClick={() => reset()}>
          {t('pages.application_roster_member.components.roster_member_filter_box.roster_member_filter_box_clear')}
        </Button>
      </Flex>
    </Box>
  );
};
